
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookObserveSpecData",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "api/sync/syncWildbook",
      form: "WildbuchEintragBeobachtungSpez",
      page: "WildbuchEintragBeobachtungDatenSpez",
      remoteId: "",
    });
    return {
      request
    };
  }
};
